import { useQuery } from '@apollo/client';
import 'react-loading-skeleton/dist/skeleton.css';
import { VStack, AspectRatio, theme, Button, useModalState, ModalInfo, Box } from '@bpba/ui-components';
import { useCallback, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import Skeleton from 'react-loading-skeleton';
import Filtro from '../components/grids/Filtro';
import { Queries } from '../rest/Queries';
import { getEstablecimientos } from '../rest/queries/getEstablecimientos';
import { Breakpoints, useMinWidth } from '../hooks/useMediaQuery';
import { GrillaDesktop } from '../components/grids/GrillaDesktop';
import { GrillaMobile } from '../components/grids/GrillaMobile';
import { FieldValues } from 'react-hook-form';
import { TIPO_PACTAR, TIPO_PROCAMPO_ARS, TIPO_PROCAMPO_USD } from '../Constantes';
import { Title } from '../components/Title';
import { Info } from '../components/Info';

type BuscadorProps = {
  tipo: string;
};

export const Buscador = ({ tipo }: BuscadorProps) => {

  const [localidad, setLocalidad] = useState();
  const [rubro, setRubro] = useState();
  const [region, setRegion] = useState();
  const [denominacion, setDenominacion] = useState();
  const isDesktop = useMinWidth(Breakpoints.SMALL_DESKTOP);
  const [isOpen, open, close] = useModalState();
  const [buscadorTipo] = useState(tipo);
  const tipoBuscador = tipo === TIPO_PACTAR ? 1 : tipo === TIPO_PROCAMPO_ARS ? 2 : 3;
  const tituloBuscador = tipo === TIPO_PACTAR ? 'Pactar Digital' : tipo === TIPO_PROCAMPO_ARS ? 'Procampo Digital ARS' : 'Procampo Digital USD';
  const [shouldITrigger, setShouldITrigger] = useState(true);



  const {
    loading,
    data: { establecimientos: { data: establecimientos, total, muestraLocalidad } = { data: [], total: 0, muestraLocalidad: false, } } = {},
    fetchMore,
  } = useQuery<Queries>(getEstablecimientos, {
    variables: { rubro, localidad, denominacion, page: 1, region, rows: 40, tipoBuscador },
    skip: !shouldITrigger,
  });

  const fetchMoreResult = (page: number) => {
    fetchMore({
      variables: { page },

      updateQuery: (previousResult, { fetchMoreResult }): Queries => {
        const newEntries = fetchMoreResult?.establecimientos?.data;
        return {
          establecimientos: {
            total: fetchMoreResult?.establecimientos?.total || 0,
            muestraLocalidad:
              fetchMoreResult?.establecimientos?.muestraLocalidad || false,
            data: [...(previousResult?.establecimientos?.data || []), ...(newEntries || [])],
          },
        };
      },
    });
  };

  const onSubmit = useCallback(
    (data: FieldValues) => {
      setDenominacion(data.denominacion);
      setLocalidad(data.localidad);
      setRubro(data.rubro);
      setRegion(data.region);
      setShouldITrigger(true);

      close();
    },
    [close]
  );

  const FiltroComponent = () => (
    <Filtro tipo={tipo} onSubmit={onSubmit} onChangeTrigger={isDesktop} defaults={{ denominacion, localidad, rubro, region }} muestraLocalidad={muestraLocalidad} />
  );

  return (
    <VStack px={2}>
      <AspectRatio ratio={2.304}>
        {tipo === TIPO_PACTAR && (
          <img style={{ borderRadius: '10px' }} src="/CDN/Get/header_buscador_pactar" alt="banner agro" aria-hidden="true"></img>
        )}
        {tipo === TIPO_PROCAMPO_ARS && (
          <img style={{ borderRadius: '10px' }} src="/CDN/Get/header_buscador_agro" alt="banner agro" aria-hidden="true"></img>
        )}
        {tipo === TIPO_PROCAMPO_USD && (
          <img style={{ borderRadius: '10px' }} src="/CDN/Get/header_buscador_agro" alt="banner agro" aria-hidden="true"></img>
        )}
      </AspectRatio>

      {tipo === TIPO_PACTAR && (
        <img style={{ maxWidth: '300px' }} src="/CDN/Get/logo_pactar_digital" />
      )}
      {(tipo === TIPO_PROCAMPO_ARS || tipo === TIPO_PROCAMPO_USD) && (
        <img style={{ maxWidth: '300px' }} src="/CDN/Get/procampodigital" />
      )}

      <Info infoList={[]} info={'Usá los filtros y encontrá las empresas adheridas.'}></Info>
      <Box flexDirection={['column', null, 'row']} justifyContent={'space-between'}>
        <VStack width={['100%', null, null, '22.5%']}>
          {isDesktop ? (
            <FiltroComponent />
          ) : (
            <>
              <Button variant="secondary" onClick={open}>
                Filtro
              </Button>
              <ModalInfo title="Filtros" show={isOpen} onClose={close} closable={false}>
                <FiltroComponent />
              </ModalInfo>
            </>
          )}
        </VStack>

        <VStack width={['100%', null, null, '72.5%']}>
          {loading && <Skeleton height="40px" count={10} baseColor={theme.colors.secondary[0]} highlightColor="#cccccc" />}
          {total > -1 && (
            <InfiniteScroll
              element="div"
              pageStart={1}
              loadMore={fetchMoreResult}
              hasMore={establecimientos.length + 1 < total}
              loader={<Skeleton key={1} height={40} count={1} baseColor={theme.colors.secondary[0]} highlightColor="#999999" />}
            >
              {!loading &&
                (isDesktop ? (
                  <GrillaDesktop establecimientos={establecimientos} tipo={buscadorTipo} muestraLocalidad={muestraLocalidad} />
                ) : (
                  <GrillaMobile establecimientos={establecimientos} tipo={buscadorTipo} />
                ))}
            </InfiniteScroll>
          )}
        </VStack>
      </Box>
    </VStack>
  );
};
